import axios from 'axios';

// Create a new axios instance for the AI server
const aiApi = axios.create({
  baseURL: 'https://vision-api.inxpect.cloud',
  timeout: 10000, // 10 second timeout
});

/**
 * Fetches the status of the AI server.
 * @returns {Promise<object>} A promise that resolves to the server status data.
 */
export const getAiServerStatus = async () => {
  try {
    const response = await aiApi.get('/status');
    return response.data;
  } catch (error) {
    console.error('Error fetching AI server status:', error);
    throw error;
  }
};

/**
 * Fetches the details of the available AI models.
 * @returns {Promise<object>} A promise that resolves to the model details data.
 */
export const getAiModelDetails = async () => {
  try {
    const response = await aiApi.get('/models/details');
    return response.data;
  } catch (error) {
    console.error('Error fetching AI model details:', error);
    throw error;
  }
};

export default {
  getAiServerStatus,
  getAiModelDetails,
};